import {SvgCapturingProgress} from "@game/ui/components/Capturing/SvgCapturingProgress";
import {Images} from "@game/ui/images";
import "./Capturing.less";

type CapturingProps = {
    stages?: number;
    captured?: number;
    title?: string;
    showGift?: boolean;
};

const DEFAULT_COUNT: number = 4;
const DEFAULT_PROGRESS: number = 0.01;

export const Capturing = ({
    stages = DEFAULT_COUNT,
    captured = DEFAULT_PROGRESS,
    title,
    showGift = true
}: CapturingProps) => (
    <div className="capturing">
        {title ? <div className="capturing__title">{title}</div> : null}

        <div className="capturing__row">
            <div className="capturing__progress">
                <SvgCapturingProgress width={482} height={76} captured={captured} stages={stages} />
            </div>

            {showGift ? (
                <div className="capturing__gift-image">
                    <Images.Gift />
                </div>
            ) : null}
        </div>
    </div>
);
